import React, { useState, useEffect, useContext } from 'react';
import { Badge, Card, Col, Pagination, Row, Table, Form, Spinner, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons';
import API from '../../utils/api';
import { Modal } from '@themesberg/react-bootstrap';
import ViewDetailsPopup from '../ViewDetailsPopup';
import Filter from '../Filter';
import { ToastAlert } from '../ToastAlert';
import StatusSelector from './StatusSelector';
import CustomStatusCell from './CustomStatusCell';
import NotesBox from '../NotesBox';
import { useTranslation } from "react-i18next";
import ClaimRow from './allClaims/ClaimRow';
import deleteIcon from '../../assets/img/bin.png';
import trashIcon from '../../assets/img/trash.png';
import ChatModal from '../ChatModal';
import { UnreadContext } from '../../utils/UnreadContext';
export const AllClaims = ({ userId, filterPaymentStatus, approvalWindow, hasChat , unreadFirst }) => {

    const { t } = useTranslation();
    const ITEMS_PER_PAGE = 8;
    let [claimsData, setClaimsData] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [currentRejectClaimId, setCurrentRejectClaimId] = useState(null);
    const [rejectReason, setRejectReason] = useState('');
    const [rejectLoading, setRejectLoading] = useState(false);
    const [showDetailsPopup, setShowDetailsPopup] = useState(false);
    const [selectedClaimId, setSelectedClaimId] = useState(null);
    const [currentFilters, setCurrentFilters] = useState({});
    const [severityLevels, setSeverityLevels] = useState({});
    const [claimTypes, setClaimTypes] = useState({});
    const [pickedDates, setPickedDates] = useState({});
    const [invoiceTypes, setInvoiceTypes] = useState({});
    const [processingClaims, setProcessingClaims] = useState({});
    const [selectedClaim, setSelectedClaim] = useState(null);
    const [selectedClaimNotes, setSelectedClaimNotes] = useState(null);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [deleteError, setDeleteError] = useState(null);
    const [userToDelete, setUserToDelete] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [claims, setClaims] = useState([]);
    const [selectedAiVariables, setSelectedAiVariables] = useState(null);
    const [showAiModal, setShowAiModal] = useState(false);
    const [processingAi, setProcessingAi] = useState({});
    const [genders, setGenders] = useState({});
    const [checks, setChecks] = useState({});
    const [addressSearch, setAddressSearch] = useState({});
    const [penaltyCharges, setPenaltyCharges] = useState({});
    const [aiVariables, setAiVariables] = useState({});
    const [customInvoiceTypes, setCustomInvoiceTypes] = useState({});
    const [activeClaimId, setActiveClaimId] = useState(null);
    const [showCustomModal, setShowCustomModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [showChatModal, setShowChatModal] = useState(false);
    const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
    // const [unreadCounts, setUnreadCounts] = useState({});
    // const [unreadUsers, setUnreadUsers] = useState({});
    const { unreadUsers, unreadCounts, fetchUnreadCounts } = useContext(UnreadContext);
    const handleChatClick = async (invoiceId) => {
        setSelectedInvoiceId(invoiceId);
        setShowChatModal(true);

        try {
            // 🔥 Call backend to mark messages as read
            await API.put(`/mark-as-read/${invoiceId}`);

            // 🔄 Refresh unread counts visually

            fetchUnreadCounts();
        } catch (err) {
            console.error("Failed to mark messages as read", err);
        }
    };


    const handleGenerateAi = async (claimId) => {
        try {
            setProcessingAi(prev => ({ ...prev, [claimId]: true }));

            const res = await API.post(
                `claims/${claimId}/generate-ai-variables`,
                {},

            );

            // Update claim in claimsData with new aiExtractedVariables
            setClaimsData(prev =>
                prev.map(c => c._id === claimId ? { ...c, aiExtractedVariables: res.data.aiVariables } : c)
            );

        } catch (err) {
            console.error("Error generating AI variables:", err);
            // alert("Failed to generate AI variables");
        } finally {
            setProcessingAi(prev => ({ ...prev, [claimId]: false }));
        }
    };

    const handleViewAi = (variables, claimId) => {
        setSelectedClaim(claimId);

        // Use edited version if exists, otherwise use original variables
        const existing = aiVariables[claimId] || variables;
        setSelectedAiVariables(existing);

        // Also make sure aiVariables state has this claim initialized
        setAiVariables(prev => ({
            ...prev,
            [claimId]: existing
        }));

        setShowAiModal(true);
    };





    const confirmDeleteUser = async () => {
        if (!userToDelete) return;

        setDeleteLoading(true); // immediately show spinner

        try {
            await API.delete(`/claims/${userToDelete}/delete`);

            const updatedUsers = claimsData.filter(claim => claim._id !== userToDelete);
            setClaimsData(updatedUsers);

            const newTotalPages = Math.max(1, Math.ceil(updatedUsers.length / ITEMS_PER_PAGE));
            if (currentPage > newTotalPages) setCurrentPage(newTotalPages);

            setDeleteSuccess(true);
            setDeleteError(null);

        } catch (err) {
            console.error("Failed to delete user:", err);
            setDeleteError("Failed to delete user. Please try again.");
        } finally {
            setDeleteLoading(false); // spinner will disappear after API call
        }
    };


    const handleStatusChange = async (id, status) => {


        try {
            const response = await API.patch(
                `/claims/${id}/status`, // Adjust API URL
                { paymentStatus: status } // use status directly
            );


            // Optional: Update local state to reflect new status
            setClaimsData(prev =>
                prev.map(claim =>
                    claim._id === id ? { ...claim, paymentStatus: status } : claim
                )
            );
        } catch (error) {
            console.error("Error updating status:", error);
        }
    };

    const [customStatuses, setCustomStatuses] = useState({});

    const handleSaveStatus = async (claimId, newValue) => {
        try {
            await API.put(`/claims/${claimId}/custom-status`, { customStatus: newValue });
            setCustomStatuses((prev) => ({
                ...prev,
                [claimId]: newValue,
            }));
        } catch (err) {
            console.error("Failed to update custom status:", err);
        }
    };

    const [alert, setAlert] = useState({
        show: false,
        message: "",
        variant: "info",
    });
    const showAlert = (message, variant = "info") => {
        setAlert({ show: true, message, variant });
    };
    // Open popup handler
    const handleViewClick = (claimId) => {
        setSelectedClaimId(claimId);
        setShowDetailsPopup(true);
    };

    // Close popup handler
    const handleClosePopup = () => {
        setShowDetailsPopup(false);
        setSelectedClaimId(null);
    };
    useEffect(() => {
        if (claimsData.length > 0) {
            const initialLevels = {};
            const initialTypes = {};
            const initialDates = {};
            const initialInvoices = {};
            const initialPenaltyCharge = {};
            const initialAddressSearch = {};
            const initialCheck = {};

            claimsData.forEach(claim => {
                initialLevels[claim._id] = claim.SeverityLevel || "";
                initialTypes[claim._id] = claim.claimType || "";
                initialDates[claim._id] = claim.NoOfDays
                    ? new Date(claim.NoOfDays).toISOString().split('T')[0] // yyyy-mm-dd format
                    : "";
                initialInvoices[claim._id] = claim.AboutInvoice || "";
                initialPenaltyCharge[claim._id] = claim.PenaltyCharge || "";
                initialAddressSearch[claim._id] = claim.AddressSearch || "";
                initialCheck[claim._id] = claim.Check;
            });
            setSeverityLevels(initialLevels);
            setClaimTypes(initialTypes);
            setPickedDates(initialDates);
            setInvoiceTypes(initialInvoices);
            setPenaltyCharges(initialPenaltyCharge);
            setAddressSearch(initialAddressSearch);
            setChecks(initialCheck);
        }
    }, [claimsData]);
    useEffect(() => {
        fetchUnreadCounts();
    }, [currentPage]);
    // Create a map once (outside component or at top)

    //    useEffect(() => {
    //   if (claimsData.length > 0) {
    //     const extracted = {};

    //     claimsData.forEach(claim => {
    //       if (claim.aiExtractedVariables) {
    //         extracted[claim._id] = claim.aiExtractedVariables;
    //       }
    //     });

    //     setAiVariables(extracted);
    //   }
    // }, [claimsData]);

    // Fetch claims from API with pagination
    // Fetch claims from API with pagination
    const fetchClaims = async (page, filters = {}) => {
        setLoading(true);
        setError(null);
        try {
            const params = { page, limit: ITEMS_PER_PAGE, ...filters };

            if (userId) {
                params.userId = userId;
            }

            // ✅ Always include filterPaymentStatus if provided
            if (filterPaymentStatus) {
                if (Array.isArray(filterPaymentStatus)) {
                    // if it's an array → join as comma separated values
                    params.paymentStatus = filterPaymentStatus.join(',');
                } else {
                    // if it's a single string
                    params.paymentStatus = filterPaymentStatus;
                }
            }
            if (approvalWindow) {
                params.approvalWindow = approvalWindow;
            }
            if (hasChat === true) {
                params.hasChat = true;
            }
              if (unreadFirst === true) {
                params.unreadFirst = true;
            }
            

            const response = await API.get(`/claims/getall`, { params });


            let claims = [];
            let totalCount = 0;

            if (response.data?.data) {
                claims = response.data.data;
                totalCount = response.data.totalCount ?? response.data.data.length;
            } else if (Array.isArray(response.data)) {
                claims = response.data;
                totalCount = response.data.length;
            }

            setClaimsData(claims);
            setTotalPages(
                response.data.totalPages ?? Math.max(1, Math.ceil(totalCount / ITEMS_PER_PAGE))
            );
        } catch (err) {
            setError("Failed to load claims");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };





    // Fetch claims on component mount and when currentPage changes
    useEffect(() => {
        fetchClaims(currentPage, currentFilters);
    }, [currentPage, currentFilters, filterPaymentStatus]);

    const handleFileUpload = (claimId, event) => {
        const file = event.target.files[0];
        setUploadedFiles((prev) => ({
            ...prev,
            [claimId]: file,
        }));
        // TODO: Implement upload API call here
    };


    const getStatusBadge = (status) => {
        switch (status) {
            case "Waiting for Admin Action":
                return <Badge bg="warning" text="dark">{t("statuses.waitingAdminAction.value")}</Badge>;
            case "In Process":
                return <Badge bg="primary">{t("Approve")}</Badge>;
            case "Closed":
                return <Badge bg="success">{t("fixedStatuses.completed")}</Badge>;
            case "Rejected":
                return <Badge bg="danger">{t("RejectedClaim")}</Badge>;
            case "Select Status":
                return <Badge bg="warning" text="dark">{t("statuses.waitingAdminAction.value")}</Badge>;
            // New statuses with custom colors
            case "debtor has paid, payment coming soon":
                return <Badge style={{ backgroundColor: "#28a745", color: "#fff" }}>{t("fixedStatuses.paid")}</Badge>;
            case "Installment payment agreement in place":
                return <Badge style={{ backgroundColor: "#17a2b8", color: "#fff" }}>{t("fixedStatuses.installmentPayment")}</Badge>;
            case "In Progress":
                return <Badge style={{ backgroundColor: "#ffc107", color: "#212529" }}>{t("fixedStatuses.debtCollectionInitiated")}</Badge>;
            case "court dunning procedure":
                return <Badge style={{ backgroundColor: "#fd7e14", color: "#fff" }}>{t("fixedStatuses.courtDunningProcedure")}</Badge>;
            case "we contact the debtor":
                return <Badge style={{ backgroundColor: "#6610f2", color: "#fff" }}>{t("fixedStatuses.resubmissions")}</Badge>;
            case "enforcement order obtained":
                return <Badge style={{ backgroundColor: "#dc3545", color: "#fff" }}>{t("fixedStatuses.foreclosures")}</Badge>;
            case "case closed":
                return <Badge style={{ backgroundColor: "#20c997", color: "#fff" }}>{t("fixedStatuses.completed")}</Badge>;
            case "cancellation":
                return <Badge style={{ backgroundColor: "#6c757d", color: "#fff" }}>{t("fixedStatuses.cancellation")}</Badge>;

            default:
                return <Badge bg="secondary">{t("Approve")}</Badge>;
        }

    };

    const renderPaginationItems = () => {
        let items = [];
        for (let number = 1; number <= totalPages; number++) {
            items.push(
                <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => {
                        setCurrentPage(number);
                        fetchClaims(number, currentFilters);
                    }}
                >
                    {number}
                </Pagination.Item>
            );
        }
        return items;
    };
    const showMandateColumns = claimsData.some(
        (claim) => claim.status !== "Waiting for Admin Action"
    );
    // Inside your component:

    const handleReject = (claimId) => {
        setCurrentRejectClaimId(claimId);
        setRejectReason('');
        setShowRejectModal(true);
    };

    const submitRejectReason = async () => {
        if (!rejectReason.trim()) {
            showAlert("Please enter a rejection reason", "warning"); // ⚠️ warning
            return;
        }

        try {
            setRejectLoading(true);
            await API.patch(`/claims/getsingle/${currentRejectClaimId}/reject`, {
                rejectionReason: rejectReason.trim(),
            });
            showAlert("Claim rejected successfully", "success");
            setShowRejectModal(false);
            fetchClaims(currentPage);
        } catch (err) {
            console.error('Failed to reject claim', err);
            showAlert("Failed to reject claim", "danger");
        } finally {
            setRejectLoading(false);
        }
    };

    const handleStart = async (claimId) => {
        try {
            await API.patch(`/claims/getsingle/${claimId}/start`);
            showAlert("Work started successfully", "success");
            fetchClaims(currentPage);
        } catch (err) {
            console.error("Failed to start work", err);
            showAlert("Failed to start work", "danger");
        }
    };

    const handleComplete = async (claimId) => {
        try {
            await API.patch(`/claims/getsingle/${claimId}/complete`);
            showAlert("Work completed successfully", "success");
            fetchClaims(currentPage);
        } catch (err) {
            console.error("Failed to complete work", err);
            showAlert("Failed to complete work", "danger");
        }
    };
    const fetchUserByClaimId = async (claimId) => {
        const response = await API.get("/profile/users/with-claims");
        const users = response.data.data || [];

        // find user whose claims include this claimId
        const user = users.find(u =>
            u.claims && u.claims.some(c => c.claimId === claimId)
        );

        return user;
    };

    const handleApprove = async (claimId) => {


        const selectedClaimType = claimTypes[claimId];
        if (!selectedClaimType) {
            showAlert("Please select a claim type before approving", "danger");
            return;
        }
        const selectedSeverity = severityLevels[claimId];
        if (!selectedSeverity) {
            showAlert("Please select a severity level before approving", "danger");
            return;
        }
        // const selectedDate = pickedDates[claimId];
        // if (!selectedDate) {
        //     showAlert("Please pick a date before approving", "danger");
        //     return;
        // }
        const selectedInvoiceType = invoiceTypes[claimId];
        if (!selectedInvoiceType) {
            showAlert("Please select an invoice type before approving", "danger");
            return;
        }


        try {
            setProcessingClaims(prev => ({ ...prev, [claimId]: true }));
            showAlert("Claim approval started. Document generation & AI processing in progress...", "info");
            const user = await fetchUserByClaimId(claimId);

            const payload = await API.patch(`/claims/getsingle/${claimId}/approve`, {
                SeverityLevel: selectedSeverity,
                claimType: selectedClaimType,
                // pickedDate: selectedDate, // send exact date
                AboutInvoice: selectedInvoiceType,
                Gender: genders[claimId] || null,
                Check: checks[claimId] || false,
                AddressSearch: addressSearch[claimId] || null,
                PenaltyCharge: penaltyCharges[claimId] || null,
                AiVariables: selectedAiVariables || {},
                comapanyNamenew: user?.companyName,
            });


            showAlert("Claim approved successfully", "success");

            // ✅ Update selected AI variables immediately with latest from backend response
            if (payload?.data?.claim?.aiVariables) {
                setSelectedAiVariables(payload.data.claim.aiVariables);
                setAiVariables(prev => ({
                    ...prev,
                    [claimId]: payload.data.claim.aiVariables
                }));
            }

            // ✅ Optionally re-fetch claims to sync everything else
            fetchClaims(currentPage);

        } catch (err) {
            console.error("Failed to approve claim", err);
            showAlert("Failed to approve claim", "danger"); // ❌ error toast
        } finally {
            // Remove processing state
            setProcessingClaims(prev => ({ ...prev, [claimId]: false }));
        }
    };

    const variableLabels = {
        DebtorName: `${t("DebtorName")}`,
        DebtorAddress1: `${t("DebtorAddress1")}`,
        DebtorAddress2: `${t("DebtorAddress2")}`,
        OriginalDueDate: `${t("OriginalDueDate")}`,
        TotalAmount: `${t("TotalAmount")}`
    };
    return (
        <>
            <ToastAlert
                show={alert.show}
                onClose={() => setAlert({ ...alert, show: false })}
                message={alert.message}
                variant={alert.variant}
            />
            <Card border="light" className="shadow-sm mt-4">
                <Card.Header>
                    <Row className="align-items-center justify-content-between">
                        <Col md={3}>
                            <h5 style={{ marginBottom: 0 }}>{t("submittedClaimsText")}</h5>
                        </Col>
                        <Col md={9} className="d-flex justify-content-end align-items-center">
                            <div style={{ width: "100%", maxWidth: "1000px", display: "flex", gap: "8px", alignItems: "center" }}>
                                <Filter
                                    fields={[
                                        {
                                            name: "status",
                                            label: "",
                                            type: "select",

                                            options: [
                                                { value: "Waiting for Admin Action", label: t("statuses.waitingAdminAction.label") },
                                                { value: "In Progress", label: t("statuses.inProgress.label") },
                                                { value: "Waiting", label: t("statuses.waiting.label") },
                                                { value: "Rejected", label: t("statuses.rejected.label") },
                                                { value: "debtor has paid, payment coming soon", label: t("statuses.debtorPaid.label") },
                                                { value: "Installment payment agreement in place", label: t("statuses.installmentAgreement.label") },
                                                { value: "court dunning procedure", label: t("statuses.courtDunning.label") },
                                                { value: "we contact the debtor", label: t("statuses.contactDebtor.label") },
                                                { value: "enforcement order obtained", label: t("statuses.enforcementOrder.label") },
                                                { value: "case closed", label: t("statuses.caseClosed.label") },
                                                { value: "cancellation", label: t("statuses.cancelled.label") },
                                            ],

                                            col: 8,
                                        },
                                        {
                                            name: "claimName",
                                            label: "",
                                            type: "text",
                                            placeholder: t("filtterClaimName"),
                                            col: 8,
                                        },
                                        {
                                            name: "fileReference",   // 👈 New field
                                            label: "",
                                            type: "text",
                                            placeholder: t("filtterFileRefrence"),
                                            col: 8,
                                        }
                                    ]}

                                    onFilterChange={(filters) => {
                                        setCurrentFilters(filters);
                                        setCurrentPage(1); // reset to first page on filter change
                                        fetchClaims(1, filters); // fetch filtered data on page 1
                                    }}
                                />

                            </div>
                        </Col>
                    </Row>
                </Card.Header>


                {loading ? (
                    <div className="d-flex justify-content-center py-5">
                        <Spinner animation="border" />
                    </div>
                ) : error ? (
                    <div className="text-danger text-center py-3">{error}</div>
                ) : (
                    <>
                        <Table responsive className="table-flush align-middle">
                            <thead className="thead-light">
                                <tr>
                                    <th>{t("tableHeaders.claimName")}</th>
                                    {/* Show these columns only if NOT waiting for admin action */}
                                    <th>{t("tableHeaders.submittedBilling")}</th>
                                    <th>{t("tableHeaders.generatedDocument")}</th>
                                    <th>{t("Amount")}</th>
                                    <th>{t("tableHeaders.severityLevel")}</th>
                                    <th>{t("tableHeaders.claimType")}</th>

                                    <th>{t("tableHeaders.invoiceType")}</th>
                                    {/* <th style={{ width: "70px" }}>Gender</th> */}
                                    <th>{t("check")}</th>
                                    <th>{t("addressSearch")}</th>
                                    <th>{t("penaltyCharge")}</th>
                                    <th>{t("tableHeaders.changeStatus")}</th>
                                    <th>{t("tableHeaders.customStatus")}</th>
                                    <th className="text-center">{t("tableHeaders.addNotes")}</th>
                                    <th>{t("tableHeaders.status")}</th>
                                    <th className="text-center" style={{ width: "80px" }}>
                                        {t("tableHeaders.actions")}
                                    </th>
                                </tr>

                            </thead>
                            <tbody>
                                {claimsData.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} className="text-center">No claims found.</td>
                                    </tr>
                                ) : (
                                    claimsData.map((claim) => (
                                        <ClaimRow
                                            claim={claim}
                                            key={claim.id}
                                            handleGenerateAi={handleGenerateAi}
                                            handleViewAi={handleViewAi}
                                            handleApprove={handleApprove}
                                            unread={unreadCounts[claim._id] || 0}
                                            unreadUsers={unreadUsers}
                                            handleReject={handleReject}
                                            handleStart={handleStart}
                                            handleComplete={handleComplete}
                                            setSelectedClaim={setSelectedClaim}
                                            setSelectedClaimNotes={setSelectedClaimNotes}
                                            setAddressSearch={setAddressSearch}
                                            addressSearch={addressSearch}
                                            handleStatusChange={handleStatusChange}
                                            checks={checks}
                                            setChecks={setChecks}
                                            claimTypes={claimTypes}
                                            setClaimTypes={setClaimTypes}
                                            customStatuses={customStatuses}
                                            handleSaveStatus={handleSaveStatus}
                                            genders={genders}
                                            setGenders={setGenders}
                                            invoiceTypes={invoiceTypes}
                                            setInvoiceTypes={setInvoiceTypes}
                                            setActiveClaimId={setActiveClaimId}
                                            setShowCustomModal={setShowCustomModal}
                                            setCustomInvoiceTypes={setCustomInvoiceTypes}
                                            penaltyCharges={penaltyCharges}
                                            setPenaltyCharges={setPenaltyCharges}
                                            pickedDates={pickedDates}
                                            setPickedDates={setPickedDates}
                                            severityLevels={severityLevels}
                                            setSeverityLevels={setSeverityLevels}
                                            getStatusBadge={getStatusBadge}
                                            processingAi={processingAi}
                                            processingClaims={processingClaims}
                                            handleViewClick={handleViewClick}
                                            setUserToDelete={setUserToDelete}
                                            setDeleteSuccess={setDeleteSuccess}
                                            setDeleteError={setDeleteError}
                                            setShowDeleteModal={setShowDeleteModal}
                                            showCustomModal={showCustomModal}
                                            customInvoiceTypes={customInvoiceTypes}
                                            activeClaimId={activeClaimId}
                                            handleChatClick={handleChatClick}
                                        />
                                    ))
                                )}
                            </tbody>
                        </Table>
                        <ViewDetailsPopup
                            show={showDetailsPopup}
                            onClose={handleClosePopup}
                            claimId={selectedClaimId}
                            isAdmin={true}
                        />
                        <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>{t('claimModalsTranslations.rejectClaim.title')}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form.Group controlId="rejectReason">
                                    <Form.Label>{t('claimModalsTranslations.rejectClaim.label')}</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={rejectReason}
                                        onChange={(e) => setRejectReason(e.target.value)}
                                        placeholder={t('claimModalsTranslations.rejectClaim.placeholder')}
                                    />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowRejectModal(false)}>
                                    {t('claimModalsTranslations.rejectClaim.buttons.cancel')}
                                </Button>
                                <Button
                                    variant="danger"
                                    onClick={submitRejectReason}
                                    disabled={!rejectReason.trim() || rejectLoading}
                                >
                                    {rejectLoading
                                        ? <Spinner animation="border" size="sm" />
                                        : t('claimModalsTranslations.rejectClaim.buttons.submitReject')}
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Notes Box */}
                        <NotesBox
                            show={Boolean(selectedClaimNotes)}
                            claimId={selectedClaimNotes}
                            isAdmin={true}
                            onClose={() => setSelectedClaimNotes(null)}
                        />

                        {/* Delete Claim Modal */}
                        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>{t('claimModalsTranslations.deleteClaim.title')}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="text-center">
                                {deleteSuccess ? (
                                    <>
                                        <div className="mb-3">
                                            <i className="fas fa-check-circle fa-3x text-success"></i>
                                            <img style={{ height: "70px", width: "70px" }} src={trashIcon} alt="" />
                                        </div>
                                        <h5 className="text-success">
                                            {t('claimModalsTranslations.deleteClaim.body.deleteSuccessTitle')}
                                        </h5>
                                        <p className="text-muted">
                                            {t('claimModalsTranslations.deleteClaim.body.deleteSuccessDescription')}
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <div className="mb-3">
                                            <i className="fas fa-exclamation-triangle fa-3x text-danger"></i>
                                            <img style={{ height: "70px", width: "70px" }} src={deleteIcon} alt="" />
                                        </div>
                                        <p className="text-muted">
                                            {t('claimModalsTranslations.deleteClaim.body.deleteWarning')} <br />
                                            <strong className="text-danger">
                                                {t('claimModalsTranslations.deleteClaim.body.deleteWarningImportant')}
                                            </strong>
                                        </p>
                                        {deleteError && <p className="text-danger mt-2">{deleteError}</p>}
                                    </>
                                )}
                            </Modal.Body>
                            <Modal.Footer className="justify-content-center">
                                {deleteSuccess ? (
                                    <Button variant="success" onClick={() => setShowDeleteModal(false)}>
                                        {t('claimModalsTranslations.deleteClaim.buttons.close')}
                                    </Button>
                                ) : (
                                    <>
                                        <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                                            {t('claimModalsTranslations.deleteClaim.buttons.cancel')}
                                        </Button>
                                        <Button variant="danger" onClick={confirmDeleteUser} disabled={deleteLoading}>
                                            {deleteLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Deleting...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-trash me-2"></i>
                                                    {t('claimModalsTranslations.deleteClaim.buttons.delete')}
                                                </>
                                            )}
                                        </Button>


                                    </>
                                )}
                            </Modal.Footer>
                        </Modal>
                        <Modal show={showAiModal} onHide={() => setShowAiModal(false)} size="xl">
                            <Modal.Header closeButton>
                                <Modal.Title>{t("extVarHead")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {selectedAiVariables ? (
                                    <div className="container-fluid">
                                        <div className="row">
                                            {Object.entries(selectedAiVariables).map(([key, value]) => (
                                                <div className="col-md-4 mb-3" key={key}>
                                                    <div
                                                        className="p-3 border rounded h-100"
                                                        style={{ borderColor: "#ddd", backgroundColor: "#fafafa" }}
                                                    >
                                                        <label className="fw-bold d-block mb-2" style={{ color: "#333" }}>
                                                            {variableLabels[key] || key} {/* fallback to key if not mapped */}
                                                        </label>
                                                        <textarea
                                                            className="form-control"
                                                            rows={3}
                                                            value={value}
                                                            onChange={(e) => {
                                                                const updated = {
                                                                    ...selectedAiVariables,
                                                                    [key]: e.target.value,
                                                                };
                                                                setSelectedAiVariables(updated);
                                                                setAiVariables(prev => ({
                                                                    ...prev,
                                                                    [selectedClaim]: updated
                                                                }));
                                                            }}
                                                            style={{ resize: "vertical" }}
                                                        />
                                                    </div>
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                ) : (
                                    <p>No variables found.</p>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowAiModal(false)}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        <Modal show={showChatModal} onHide={() => setShowChatModal(false)} centered size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title>{t("ChatHeading")} </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <ChatModal invoiceId={selectedInvoiceId} />
                            </Modal.Body>
                        </Modal>




                        {/* Pagination */}
                        {totalPages > 1 && (
                            <Pagination className="justify-content-center mt-3">
                                <Pagination.Prev
                                    onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    {t('claimModalsTranslations.pagination.previous')}
                                </Pagination.Prev>
                                {renderPaginationItems()}
                                <Pagination.Next
                                    onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    {t('claimModalsTranslations.pagination.next')}
                                </Pagination.Next>
                            </Pagination>
                        )}
                    </>
                )}
            </Card>
        </>

    );
};
